import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/styles/_base.scss";
import formatLabelPlugin from './plugins/format-label'
import FormFieldsPlugin  from './components/forms'

const meta = document.querySelector('meta[name="app-version"]');

if (meta) {
  const current = meta.getAttribute("content");
  const stored = localStorage.getItem("app_version");
  if (stored && stored !== current) {
    localStorage.setItem("app_version", current);
    window.location.reload();
  } else {
    localStorage.setItem("app_version", current);
  }
}

createApp(App).use(router).use(store).use(formatLabelPlugin).use(FormFieldsPlugin).mount("#app");
